import { useState } from "react";

const initialForm = {
  id: null,
  name: "",
  phone_number: "",
  klpd: "",
  position_id: "",
  institution_or_business: "",
  location: "",
};

export default function useLeadForm() {
  const [form, setForm] = useState(initialForm);
  const [errors, setErrors] = useState({});
  const [validated, setValidated] = useState(false);

  const validate = () => {
    const newErrors = {};

    if (!form.name.trim()) newErrors.name = "Nama wajib diisi.";
    if (!form.phone_number) {
      newErrors.phone_number = "Nomor Telepon wajib diisi.";
    } else if (!/^08/.test(form.phone_number)) {
      newErrors.phone_number = "Nomor harus dimulai dengan 08.";
    } else if (form.phone_number.length > 13) {
      newErrors.phone_number = "Nomor maksimal 13 digit.";
    }

    if (!form.klpd) newErrors.klpd = "KLPD wajib diisi.";
    if (!form.position_id) newErrors.position_id = "Jabatan wajib diisi.";
    if (!form.institution_or_business.trim()) newErrors.institution_or_business = "Instansi / Satker wajib diisi.";
    if (!form.location.trim()) newErrors.location = "Lokasi wajib diisi.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    const parsedValue =
      name === "phone_number" ? value.replace(/\D/g, "") : value;
    
    const updatedForm = {
      ...form,
      [name]: parsedValue,
    };

    setForm(updatedForm);
  };

  const resetForm = () => {
    setForm(initialForm);
    setErrors({});
    setValidated(false);
  };

  return {
    form,
    setForm,
    errors,
    validated,
    setValidated,
    validate,
    handleChange,
    resetForm,
    setErrors
  };
}
